import type { ColumnSort } from '@tanstack/react-table';

export enum SortDirection {
  Desc = 'desc',
  Asc = 'asc',
}

export const defaultSorting: ColumnSort = {
  id: 'createdAt',
  desc: true,
};

export const ACTION_COLUMN_WIDTH = 36;
